// @ts-check
import { useCallback, useEffect, useState } from 'react';
import api from '../utils/apiClient';

/**
 * Undismissed admin alerts (e.g. a background job that needs attention, like a paused WhatsApp
 * campaign). Shared by the Dashboard's own banner and the global AdminLayout banner, so an alert
 * is seen from any page, not only when the admin happens to open the Dashboard.
 */
export default function useAdminAlerts() {
  const [alerts, setAlerts] = useState([]);

  const load = useCallback(async () => {
    try {
      const data = await api.get('/api/admin/alerts?dismissed=false');
      setAlerts(data || []);
    } catch (error) {
      console.error('Failed to load alerts:', error);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const dismiss = useCallback(async (alertId) => {
    await api.patch(`/api/admin/alerts/${alertId}/dismiss`);
    setAlerts((prev) => prev.filter((a) => a.id !== alertId));
  }, []);

  return { alerts, dismiss, reload: load };
}
